/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useMemo, useState } from 'react';
import { TextureLoader } from 'three';
import { useThree, useLoader } from '@react-three/fiber';

import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { MetalStripeImg } from '../../../../../../utils/Textures';
import { delModel, extrudeSettings, textureAnisotropy } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import useMouseEvents from '../../../../../../hooks/useMouseEvents';
import { controls } from '../../../../../../redux/reducers/eventReducer';

const InsideWallModel = () => {
    const { gl } = useThree();

    const [wallCloseState, setWallCloseState] = useState(0);
    const [leftStorageWallHeight, setLeftStorageWallHeight] = useState(params.p_h);
    const [rightStorageWallHeight, setRightStorageWallHeight] = useState(params.p_h);
    // const [CSGWallModelGeometry, setCSGWallModelGeometry] = useState(null);

    const texture = const_var.metalTexture

    const rightHeight = useMemo(() => ((params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) :  params.p_h), [params.singleSlope, params.freeStandingSide, params.p_w, params.p_h, params.p_r_p])
    const leftHeight = useMemo(() => ((params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) :  params.p_h), [params.singleSlope, params.freeStandingSide, params.p_w, params.p_h, params.p_r_p])

    const wallModel = useMemo(() => {
        let model = new THREE.Shape();

        if (wallCloseState > -1) {
            if (params.p_r_s === 1) {
                const innerRoofWidth = params.p_w - 0.01
                const innerRoofPorchSize = params.p_r_p - 0.02
                
                model.moveTo(-innerRoofWidth / 2 + 0.0001, params.p_h);
    
                model.lineTo(-innerRoofWidth / 2 + 0.01, params.p_h + 0.3);
                model.lineTo(-innerRoofWidth / 2 + 0.03, params.p_h + 0.34);
                model.lineTo(-innerRoofWidth / 2 + 0.07, params.p_h + 0.38);
                model.lineTo(-innerRoofWidth / 2 + 0.1, params.p_h + 0.39);
        
                model.lineTo(0, params.p_h + (innerRoofPorchSize / 12) * innerRoofWidth / 2 + 0.39);
        
                model.lineTo(innerRoofWidth / 2 - 0.1, params.p_h + 0.39);
                model.lineTo(innerRoofWidth / 2 - 0.07, params.p_h + 0.38);
                model.lineTo(innerRoofWidth / 2 - 0.03, params.p_h + 0.34);
                model.lineTo(innerRoofWidth / 2 - 0.01, params.p_h + 0.3);
        
                model.lineTo(innerRoofWidth / 2 +0.005, params.p_h);
    
                model.lineTo(innerRoofWidth / 2 +0.005, wallCloseState);

                if (rightStorageWallHeight !== 0) {
                    model.lineTo(innerRoofWidth / 2 +0.005, 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) , 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) , wallCloseState);
                }

                if (leftStorageWallHeight !== 0) {
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), wallCloseState);
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                    model.lineTo(-innerRoofWidth / 2 +0.005, 0);
                }

                model.lineTo(-innerRoofWidth / 2 +0.005, wallCloseState);
        
                model.closePath()
        
            } else if (params.p_r_s === 2 || params.p_r_s === 3) {
                model.moveTo(-params.p_w / 2, leftHeight - 0.001);
                if(!params.singleSlope) model.lineTo(0, params.p_h + (params.p_r_p / 12) * params.p_w / 2);
                model.lineTo(params.p_w / 2, rightHeight - 0.001);
                model.lineTo(params.p_w / 2, wallCloseState);

                if (rightStorageWallHeight !== 0) {
                    model.lineTo(params.p_w / 2, 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) , 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) , wallCloseState);
                }

                if (leftStorageWallHeight !== 0) {
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), wallCloseState);
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                    model.lineTo(-params.p_w / 2, 0);
                }

                model.lineTo(-params.p_w / 2, wallCloseState);
                model.closePath()
            }
        } else {
            if (leftStorageWallHeight !== 0) {
                if (params.p_r_s === 1) {
                    const innerRoofWidth = params.p_w - 0.01
                    const innerRoofPorchSize = params.p_r_p - 0.02
                    
                    model.moveTo(-innerRoofWidth / 2 + 0.0001, params.p_h);
        
                    model.lineTo(-innerRoofWidth / 2, params.p_h + 0.3);
                    model.lineTo(-innerRoofWidth / 2 + 0.03, params.p_h + 0.33);
                    model.lineTo(-innerRoofWidth / 2 + 0.06, params.p_h + 0.37);
                    model.lineTo(-innerRoofWidth / 2 + 0.1, params.p_h + 0.39);
            
                    if (parseInt(params.cB_addStorage_left) > params.p_w / 2) {
                        model.lineTo(0, params.p_h + (innerRoofPorchSize / 12) * innerRoofWidth / 2 + 0.39);
                    }

                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), leftStorageWallHeight - 0.02);
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                    model.lineTo(-innerRoofWidth / 2 +0.005, 0);
            
                    model.closePath()
            
                } else if (params.p_r_s === 2 || params.p_r_s === 3) {
                    model.moveTo(-params.p_w / 2, leftHeight - 0.001);
                    if (parseInt(params.cB_addStorage_left) > params.p_w / 2) {
                        if(!params.singleSlope) model.lineTo(0, params.p_h + (params.p_r_p / 12) * params.p_w / 2);
                    }
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), leftStorageWallHeight - 0.02);
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                    model.lineTo(-params.p_w / 2, 0);
                    model.closePath()
                }
            }

            if (rightStorageWallHeight !== 0) {
                if (params.p_r_s === 1) {
                    const innerRoofWidth = params.p_w - 0.01
                    const innerRoofPorchSize = params.p_r_p - 0.02
                    
                    model.moveTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), rightStorageWallHeight - 0.02);
            
                    if (parseInt(params.cB_addStorage_right) > params.p_w / 2) {
                        model.lineTo(0, params.p_h + (innerRoofPorchSize / 12) * innerRoofWidth / 2 + 0.39);
                    }
            
                    model.lineTo(innerRoofWidth / 2 - 0.1, params.p_h + 0.39);
                    model.lineTo(innerRoofWidth / 2 - 0.06, params.p_h + 0.37);
                    model.lineTo(innerRoofWidth / 2 - 0.03, params.p_h + 0.33);
                    model.lineTo(innerRoofWidth / 2, params.p_h + 0.3);
            
                    model.lineTo(innerRoofWidth / 2 +0.005, params.p_h);
        
                    model.lineTo(innerRoofWidth / 2 +0.005, 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0);
            
                    model.closePath()
            
                } else if (params.p_r_s === 2 || params.p_r_s === 3) {
                    model.moveTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), rightStorageWallHeight - 0.02);

                    if (parseInt(params.cB_addStorage_right) > params.p_w / 2) {
                        if(!params.singleSlope) model.lineTo(0, params.p_h + (params.p_r_p / 12) * params.p_w / 2);
                    }

                    model.lineTo(params.p_w / 2, rightHeight - 0.001);
                    model.lineTo(params.p_w / 2, 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0);
                    model.closePath()
                }
            }
        }

        return model;
    
    }, [wallCloseState, params.p_r_s, params.p_w, params.p_r_p, params.p_h, rightStorageWallHeight, leftStorageWallHeight, params.singleSlope && params.freeStandingSide === "left"])

    const dutchDelModel = useMemo(() => {
        const freeSpace = 1;
        const cornerFreeSpaceW = freeSpace * 2;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) :  params.p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = cornerFreeSpaceW;
        
        if (/* !params.cB_addStorage_check_right && !params.cB_addStorage_check_right && */ (params.p_f_w === "Half Dutch End" || params.p_f_w === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.p_w / 2 - freeSpace), 0);

            if (params.p_f_w === "Half Dutch End") {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
            } else {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace);
            }
            model.lineTo((params.p_w / 2 - freeSpace), 0);

            return model;
        } else {
            return []
        }
    }, [params.p_w, params.p_h, params.p_f_w])

    /************** cutting hole using CSG ***************/

    const CSGWallModelGeometry = useMemo(() => {
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wallModel, extrudeSettings(0.005)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('front', 'wall'), extrudeSettings(1)))
        const meshDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))
    
        let meshWallModel_Temp = meshWallModel.clone();
        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(0, 0, -0.5);
    
        // mesh to cut the dutch model
        let meshDutchDelModel_Temp = meshDutchDelModel.clone();
       
        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshDutchDelModel_CSG = CSG.fromMesh(meshDutchDelModel_Temp);
    
        const wallModel_CSG = meshWallModel_CSG.subtract(meshDelModel_CSG);
        const FrontWallModel_CSG = wallModel_CSG.subtract(meshDutchDelModel_CSG);
        const CSGWallModel = CSG.toMesh(
            FrontWallModel_CSG,
            new THREE.Matrix4()
        )

        // setCSGWallModelGeometry(CSGWallModel.geometry);

        return CSGWallModel.geometry;

    }, [params.p_w, params.p_h, params.p_f_w, wallCloseState, params.p_r_s, params.p_r_p, rightStorageWallHeight, leftStorageWallHeight, params.singleSlope && params.freeStandingSide === "left", const_var.newDoorsArray]);


    /****************************************** *********/

    useMemo(() => {
        let wallCloseValue = -1;
        let leanHeightValue = -1;

        if (params.p_f_w === 'Open') {
            wallCloseValue = -1;
        } else if (params.p_f_w === "Gable") {
            wallCloseValue = leftHeight - 0.2;
        } else if (params.p_f_w === "Extended Gable") {
            wallCloseValue = leftHeight - 3;
        } else if (params.p_f_w === "One_Fourth_Close") {
            wallCloseValue = (leftHeight * 3) / 4;
        } else if (params.p_f_w === "Half_Close") {
            wallCloseValue = leftHeight / 2;
        } else if (params.p_f_w === "Three_Fourth_Close") {
            wallCloseValue = leftHeight / 4;
        } else if (params.p_f_w === "Close" || params.p_f_w === "Half Dutch End" || params.p_f_w === "Half End") {
            wallCloseValue = 0;
        }

        if (params.add_front_lean) {
            let leanFinalHeight = params.p_h - (params.leanF_p_h + (parseInt(params.b_l_t_r_pF)/12) * params.leanF_p_w);
            if(params.add_front_lean ==true && Object.values(const_var.wallArray["front"])[0] == params.p_f_w || params.add_front_lean ==true && params.p_f_w == "Open")
            {    
              params.p_f_w = params.p_f_wF
              let wH = leanFinalHeight+0.2;
              setWallCloseState(params.p_h - wH);

            }else{
                setWallCloseState(wallCloseValue);
            }
        } else {
            setWallCloseState(wallCloseValue);
        }

    
    }, [params.p_f_w, leftHeight, params.add_front_lean, params.leanF_p_h, params.b_l_t_r_pF, params.leanF_p_w])

    useMemo(() => {
        if (params.cB_addStorage_check_left) {
            let overHeight = 0;
            if ((parseInt(params.cB_addStorage_left) < params.p_w / 2) || (params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right"))) {
                if (params.p_r_s === 1) {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                } else {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                }
            } else {
                if (params.p_r_s === 1) {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                }
            }
    
            setLeftStorageWallHeight(leftHeight + overHeight);
        } else {
            setLeftStorageWallHeight(0);
        }
    
    }, [params.cB_addStorage_check_left, params.cB_addStorage_left, params.p_r_s, params.p_r_p, params.p_w, params.p_h])

    useMemo(() => {
        if (params.cB_addStorage_check_right) {
            let overHeight = 0;
            if (parseInt(params.cB_addStorage_right) < params.p_w / 2 && !params.singleSlope) {
                if (params.p_r_s === 1) {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                } else {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                }
            } else {
                if (params.p_r_s === 1) {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                }
            }
    
            setRightStorageWallHeight(leftHeight + overHeight);
        } else {
            setRightStorageWallHeight(0);
        }
    
    }, [params.cB_addStorage_check_right, params.cB_addStorage_right, params.p_r_s, params.p_r_p, params.p_w, leftHeight])

    useMemo(() => {
        textureAnisotropy(gl, texture, 1.3, 1.3, params.p_v_w ? Math.PI / 2 : 0);    
    }, [params.p_v_w])
    
    const handleMouseEvent = (e) => {
        if (params.activeWall !== "c_b_f_s_w") {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

    return  CSGWallModelGeometry && (       
        <group {...eventHandlers}>
            <mesh name="front_leg_inside_wall" geometry={CSGWallModelGeometry} position={[0, 0, params.p_d / 2 + 0.13]}>
                <meshBasicMaterial map={texture}  side={THREE.DoubleSide} color={"#C9C9C9"}  transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02}/>
            </mesh>
        </group>
    )
}

export default InsideWallModel